import image1 from '../Images/SlabsLandscape.png';
import image2 from '../Images/RetainingWallAndGrass.png';
import image3 from '../Images/BackLawn.png';
import image4 from '../Images/BarkAndRockSlabs.png';
import image5 from '../Images/fence.png';
import image6 from "../Images/Grass.jpg";
import image7 from "../Images/LongFence.jpg";
import image8 from "../Images/Mulch.jpg";
import image9 from "../Images/Patio.jpg";
import image10 from "../Images/CleanTree.jpg";
import image11 from "../Images/frontLawn.png";
import image12 from "../Images/LA_Fountain.png";
import image13 from "../Images/frontFence.png";
import image14 from "../Images/LAS_Back.png";
import image15 from "../Images/SCT_Front.png";
import image16 from "../Images/planterBox.png";
import image17 from "../Images/MPA_Roses.png";
import image18 from "../Images/frontMulch.png";
import image19 from "../Images/PacificaLawn.png";
import image20 from "../Images/parkBark.png";
import image21 from "../Images/RWC_PebbleWW.png";
import image22 from "../Images/RWCLawn.png";
import image23 from "../Images/weedCleanup.png";
import image24 from "../Images/PA_Powerwash.png";
import image25 from "../Images/BarnGate.jpg";
import image26 from "../Images/GardenBox.jpg";
import image27 from "../Images/GateSC.jpg";
import image28 from "../Images/KuraCirclejpg.jpg";
import image29 from "../Images/KuraWalkway.jpg";
import image30 from "../Images/PAPlants.jpg";
import image31 from "../Images/SCCindyFront.jpg";
import image32 from "../Images/SCMeshFence.jpg";
import image33 from "../Images/SCMeshGatejpg.jpg";
import image34 from "../Images/SCPatio.jpg";
import image35 from "../Images/SCPowerwash.jpg";
import image36 from "../Images/SJLantana.jpg";
import image37 from "../Images/KuraBackyardjpg.jpg";
import image38 from "../Images/ChabadTrees.jpg";
import image39 from "../Images/CherryBlosomsjpg.jpg";
import image40 from "../Images/RWCWeedCleanup.jpg";
import image41 from "../Images/TreeTrunk.jpg";
import image42 from "../Images/FrontTurf.jpg";





export const yardImages = [{src: image1, alt:"Front Yard Slabs", text:"Rocks Slabs Landscape"},
{src: image2, alt:"Retaining wall", text:"Retaining Wall and Artifical Lawn"},
{src: image3, alt:"Backyard Lawn", text:"New Back Yard Sod"},
{src: image4, alt:"Bark and slabs", text:"Bark and Rock Slabs"},
{src: image5, alt:"Backyard Fence", text:"New Redwood fence"}
]


export const yardImages2 = [
    {src: image6, alt:"Front yard sod", text:"New Front Yard Sod"},
    {src: image7, alt:"Long Fence", text:"70 Foot Fence"},
    {src: image8, alt:"Front Yard mulch", text:"Front Yard Mulch and Clean-Up"},
    {src: image9, alt:"Brick Patio", text:"Brick Patio"},
    {src: image10, alt:"Clean Tree", text:"Perfectly Trimmed Tree"}
    ]
    
export const allImages = [
    {src: image1, alt:"Front Yard Slabs", text:"Sand Flagstone and Center Plants", categories: ["Landscaping", "Pavers"]},
    {src: image2, alt:"Retaining wall", text:"Retaining Wall + Steps and Artifical Lawn", category: "Landscaping"},
    {src: image3, alt:"Backyard Lawn", text:"New Back Yard Sod", category: "Maintenance"},
    {src: image4, alt:"Bark and slabs", text:"Bark and Sand Flagstones", category: "Landscaping"},
    {src: image5, alt:"Backyard Fence", text:"New 30ft Redwood fence and Black Bark", category: "Fence"},
    {src: image6, alt:"Front yard sod", text:"New Front Yard Sod", category: "Maintenance"},
    {src: image7, alt:"Long Fence", text:"70 Foot Redwood Fence and Planter Box", category: "Fence"},
    {src: image8, alt:"Front Yard mulch", text:"Front Yard Mulch and Clean-Up", category: "Maintenance"},
    {src: image9, alt:"Brick Patio", text:"Brick Patio", category: "Pavers"},
    {src: image10, alt:"Clean Tree", text:"Perfectly Trimmed Tree", category: "Tree"},
    {src: image11, alt:"Front Lawn", text:"Freshly Installed Front Yard Sod", category: "Maintenance"},
    {src: image12, alt:"Fountain Plants", text:"Beautiful Fountain with Plants and Flagstones", category: "Landscaping"},
    {src: image13, alt:"Front Fence", text:"New 40ft Front Yard Fence", category: "Fence"},
    {src: image14, alt:"Back Yard Landscape", text:"Back Yard Maintenance", category: "Maintenance"},
    {src: image15, alt:"Front Yard Clean Up", text:"Front Yard Artificial Lawn and River Rock", category: "Landscaping"},
    {src: image16, alt:"Planter Box", text:"Custom Wooden Planter Box", category: "Landscaping"},
    {src: image17, alt:"Roses", text:"Beautiful Maintained Rose Bushes", category: "Maintenance"},
    {src: image18, alt:"Front Mulch", text:"Fresh Black Mulch", category: "Maintenance"},
    {src: image19, alt:"Pacifica Lawn", text:"New Lush Back Yard Sod", category: "Landscaping"},
    {src: image20, alt:"Park Bark", text:"Park Area With Fresh Red Bark", category: "Landscaping"},
    {src: image21, alt:"RWC Pebble Walkway", text:"Pebble Stone Walkway", category: "Pavers"},
    {src: image22, alt:"RWC Lawn", text:"Lush Green Maintained Lawn", category: "Maintenance"},
    {src: image23, alt:"Weed Cleanup", text:"Seasonal Weed Cleanup", category: "Landscaping"},
    {src: image24, alt:"Power Washing", text:"Patio Power Washing", category: "Landscaping"},
    {src: image25, alt:"Barn Gate", text:"Custom Barn Style Gate", category: "Fence"},
    {src: image26, alt:"Garden Box", text:"Pavers + Garden Box", category: "Pavers"},
    {src: image27, alt:"Gate", text:"Custom Redwood Gate", category: "Fence"},
    {src: image28, alt:"Porcelain Circle", text:"Porcelain Circle + Plants", categories: ["Landscaping", "Pavers"]},
    {src: image29, alt:"Porcelain Walkway", text:"Porcelain Walkway + Plants", category: "Pavers"},
    {src: image30, alt:"Plants", text:"Beautiful Plants and Mulch", category: "Landscaping"},
    {src: image31, alt:"Cindy Front", text:"Front Yard Curb Appeal", category: "Maintenance"},
    {src: image32, alt:"Mesh Fence", text:"Redwood Mesh Fence", category: "Fence"},
    {src: image33, alt:"Mesh Gate", text:"Redwood Mesh Gate + Fence", category: "Fence"},
    {src: image34, alt:"Patio", text:"Power Washed Patio", category: "Maintenance"},
    {src: image35, alt:"Powerwash", text:"Sideyard Powerwashed", category: "Maintenance"},
    {src: image36, alt:"Lantana", text:"Front Yard Landscape", categories: ["Landscaping", "Pavers"] },
    {src: image37, alt:"Backyard", text:"Full Backyard Makeover", category: "Landscaping"},
    {src: image38, alt:"Trees", text:"Trimmed Trees", category: "Tree"},
    {src: image39, alt:"Cherry Blossoms", text:"Tree Maintenance", category: "Tree"},
    {src: image40, alt:"Weed Cleanup", text:"Seasonal Weed Cleanup", category: "Landscaping"},
    {src: image41, alt:"Tree Removal", text:"Dead Oak Tree Removal", category: "Tree"},
    {src: image42, alt:"Artificial Turf", text:"Front Yard Artificial Turf", category: "Landscaping"}

]